<template>
  <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
    <el-form-item label="问题" prop="title">
      <el-input v-model="ruleForm.title"></el-input>
    </el-form-item>
    <el-form-item label="选项">
      <el-form-item label="A" prop="option_A" style="margin-bottom: 20px">
        <el-input v-model="ruleForm.option_A"></el-input>
      </el-form-item>
      <el-form-item label="B" prop="option_B">
        <el-input v-model="ruleForm.option_B"></el-input>
      </el-form-item>
    </el-form-item>
    <el-form-item label="允许报名" prop="allow">
      <el-select v-model="ruleForm.allow" multiple style="width: 100%">
        <el-option label="普通课程" value="1" :disabled="notIn(ruleForm.not_allow, 1)"></el-option>
        <el-option label="初级课程" value="2" :disabled="notIn(ruleForm.not_allow, 2)"></el-option>
        <el-option label="中级课程" value="3" :disabled="notIn(ruleForm.not_allow, 3)"></el-option>
        <el-option label="高级课程" value="4" :disabled="notIn(ruleForm.not_allow, 4)"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="不允许报名" prop="not_allow">
      <el-select v-model="ruleForm.not_allow" multiple style="width: 100%">
        <el-option label="普通课程" value="1" :disabled="notIn(ruleForm.allow, 1)"></el-option>
        <el-option label="初级课程" value="2" :disabled="notIn(ruleForm.allow, 2)"></el-option>
        <el-option label="中级课程" value="3" :disabled="notIn(ruleForm.allow, 3)"></el-option>
        <el-option label="高级课程" value="4" :disabled="notIn(ruleForm.allow, 4)"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label-width="0" style="text-align: center">
      <el-button type="primary" @click="saveCapture('ruleForm')">保存</el-button>
      <el-button @click="$emit('closeBox')">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { addCondition, editCondition } from "@/api/edu.js";
import { getLiveType, addLive, getLiveDetail, editLive } from "@/api/live.js";
import { getTeacherList } from "@/api/teacher.js";
export default {
  components: {},
  data() {
    return {
      dates: [],
      loading: false,
      typeList: [],
      captureList: [],
      conditionList: [],
      teacherList: [],
      ruleForm: {
        cate_uuid: [],
      },
      rules: {
        title: [
          {
            required: true,
            message: "请输入课节名称",
            trigger: "blur",
          },
        ],
        option_A: [
          {
            required: true,
            message: "请输入选项A",
            trigger: "blur",
          },
        ],
        option_B: [
          {
            required: true,
            message: "请输入选项B",
            trigger: "blur",
          },
        ],
        // allow: [{
        //     required: true,
        //     message: '请选择',
        //     trigger: 'change'
        // }],
        // not_allow: [{
        //     required: true,
        //     message: '请选择 ',
        //     trigger: 'change'
        // }],
        paper_uuid: [
          {
            required: true,
            message: "关联试卷",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    notIn(list, i) {
      if (!Array.isArray(list)) {
        return false;
      }
      return list.includes(i + "");
    },
    saveCapture() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          const data = {
            ...this.ruleForm,
            course_uuid: this.$route.query.uuid,
          };
          this.$emit("saveForm", data);
          this.$emit("closeBox");
          return;
          if (this.ruleForm.uuid) {
            this.editSave(data, this.ruleForm.uuid);
          } else {
            this.addSave(data);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    initData(row) {
      this.ruleForm = { ...row };
    },

    editSave(data, uuid) {
      editCondition(data, uuid).then((res) => {
        if (res) {
          this.$message.success("编辑成功");

          this.$emit("getList");
          this.$emit("closeBox");
        }
      });
    },
    addSave(data) {
      addCondition(data).then((res) => {
        console.log(res);
        if (res) {
          this.$message.success("新增成功");

          this.$emit("getList");
          this.$emit("closeBox");
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.option {
  display: flex;

  & > span {
    width: 50%;
  }
}
</style>
